/* eslint-disable arrow-body-style */

import {Actions, createEffect, ofType} from "@ngrx/effects";
import {inject} from "@angular/core";
import {DealSensitivityActions, DealSensitivityDetailsActions} from "./deal-sensitivity.actions";
import {catchError, exhaustMap, map, of, tap} from "rxjs";
import {ErrorHandlingUtil} from "../../../shared/utils/error-handling-util";
import {DealSensitivityService} from "../../services/deal-sensitivity.service";
import {ComputeSensitivitiesRequest} from "../../generated-sources/api/deal";
import {COLUMN_TOKENS_STORAGE_KEY} from "./deal-sensitivity.state";

export const loadDealSensitivityOverview = createEffect(
    (actions$ = inject(Actions),
     dealSensitivityService = inject(DealSensitivityService)) => {
        return actions$.pipe(
            ofType(DealSensitivityActions.load),
            exhaustMap((action) => {
                if (!action.dealId) {
                    return of(DealSensitivityActions.loadError({errorMsg: "Deal could not be found"}));
                }
                return dealSensitivityService.getSensitivityForDeal(action.dealId).pipe(
                    map((dealSensitivityOverview) => DealSensitivityActions.loadSuccess({dealSensitivityOverview})),
                    catchError((errorResponse: any) => of(DealSensitivityActions.loadError({errorMsg: ErrorHandlingUtil.getErrorMessage(errorResponse)})))
                );
            })
        );
    },
    {functional: true}
);

export const computeDealSensitivities = createEffect(
    (actions$ = inject(Actions),
     dealSensitivityService = inject(DealSensitivityService)) => {
        return actions$.pipe(
            ofType(DealSensitivityActions.compute),
            exhaustMap((action) => {
                if (!action.dealId) {
                    return of(DealSensitivityActions.computeError({errorMsg: "Deal could not be found"}));
                }
                const request: ComputeSensitivitiesRequest = {
                    step: action.step,
                    steps: action.steps,
                    paramType: action.paramType
                };
                return dealSensitivityService.computeSensitivitiesForDeal(action.dealId, request).pipe(
                    map((dealSensitivityOverview) => DealSensitivityActions.computeSuccess({dealSensitivityOverview})),
                    catchError((errorResponse: any) => of(DealSensitivityActions.computeError({errorMsg: ErrorHandlingUtil.getErrorMessage(errorResponse)})))
                );
            })
        );
    },
    {functional: true}
);

export const loadDealSensitivityDetails = createEffect(
    (actions$ = inject(Actions),
     dealSensitivityService = inject(DealSensitivityService)) => {
        return actions$.pipe(
            ofType(DealSensitivityDetailsActions.load),
            exhaustMap((action) => {
                if (!action.dealId || !action.dealSensitivityId) {
                    return of(DealSensitivityDetailsActions.loadError({errorMsg: "Deal or Sensitivity could not be found"}));
                }
                return dealSensitivityService.getSensitivityDetailsForDeal(action.dealId, action.dealSensitivityId).pipe(
                    map((dealSensitivity) => DealSensitivityDetailsActions.loadSuccess({dealSensitivity})),
                    catchError((errorResponse: any) => of(DealSensitivityDetailsActions.loadError({errorMsg: ErrorHandlingUtil.getErrorMessage(errorResponse)})))
                );
            })
        );
    },
    {functional: true}
);

export const persistColumnTokens = createEffect(
    (actions$ = inject(Actions)) =>
        actions$.pipe(
            ofType(DealSensitivityActions.setColumnTokens),
            tap(({tokens}) => localStorage.setItem(COLUMN_TOKENS_STORAGE_KEY, JSON.stringify(tokens)))
        ),
    {functional: true, dispatch: false}
);
